/**
 * Maison Ramure motion.
 * Deliberately quiet: text never waits for an animation. Photos marked
 * [data-mr-media] fade in once when they scroll into view; photos already on
 * screen at load are left alone. Nothing runs with reduced motion.
 */
(function () {
  if (window.__mrMotion) return;
  window.__mrMotion = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function start() {
    var items = document.querySelectorAll('[data-mr-media]');
    if (!items.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -4% 0px', threshold: 0 }
    );

    var fold = window.innerHeight;
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('mr-media-wait');
      io.observe(el);
    });

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
